import { useRef } from 'react';
import type { FilterSessionValue } from '@/app/common/filters/session/sessionState.ts';
import { promoteValues } from '@/app/common/filters/session/sessionUpdate.ts';

export type PressedOrder = {
  order: () => FilterSessionValue[];
  reset: () => void;
  record: (added: FilterSessionValue[]) => void;
};

// A surface that commits many toggles in one Apply is the only place the order the user reached for
// them exists: keep it here, so Recently used ranks by recency instead of by option position.
export const usePressedOrder = (): PressedOrder => {
  const pressed = useRef<FilterSessionValue[]>([]);

  return {
    order: () => pressed.current,
    reset: () => {
      pressed.current = [];
    },
    record: (added: FilterSessionValue[]) => {
      pressed.current = promoteValues(pressed.current, added);
    },
  };
};
